export default __webpack_public_path__ + "static/media/DiscordLogo.81fb2a72.svg";